import {Component, inject} from '@angular/core';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [],
  template: `
    @if (toastService.toasts().length) {
      <div class="toast toast-top toast-end z-[1000]">
        @for (toast of toastService.toasts(); track toast.id) {
          <div
            class="alert shadow-lg pointer-events-auto"
            [class.alert-info]="toast.type === 'info'"
            [class.alert-success]="toast.type === 'success'"
            [class.alert-warning]="toast.type === 'warning'"
            [class.alert-error]="toast.type === 'error'"
          >
            <span>{{ toast.message }}</span>
            <button class="btn btn-ghost btn-xs" type="button" (click)="toastService.remove(toast.id)">
              ✕
            </button>
          </div>
        }
      </div>
    }
  `,
  styles: ``
})
export class ToastComponent {
  toastService = inject(ToastService);
}
